import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '@/data/site';

type EnquiryPageShellProps = {
  eyebrow: string;
  title: string;
  intro: ReactNode;
  price?: string;
  priceNote?: string;
  children: ReactNode;
};

export default function EnquiryPageShell({
  eyebrow,
  title,
  intro,
  price,
  priceNote,
  children,
}: EnquiryPageShellProps) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 pt-36 pb-20 md:pt-48 md:pb-28 bg-background-50">
      <div className="max-w-content mx-auto max-w-3xl">
        <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
          {eyebrow}
        </span>
        <h1 className="mt-5 font-heading text-3xl md:text-5xl leading-[1.1] text-foreground-950">
          {title}
        </h1>
        <div className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700 space-y-3">
          {intro}
        </div>

        {price ? (
          <div className="mt-6 inline-flex items-baseline gap-3 rounded-md border border-background-200 bg-background-100 px-5 py-3">
            <span className="font-heading text-2xl text-primary-300">{price}</span>
            {priceNote ? <span className="text-[15px] text-foreground-600">{priceNote}</span> : null}
          </div>
        ) : null}

        <div className="mt-10">{children}</div>

        <div className="mt-10 pt-8 border-t border-background-200">
          <p className="font-label text-sm uppercase tracking-[0.14em] text-foreground-600 mb-4">
            Other ways to work with us
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {SERVICES.map((service) => (
              <Link
                key={service.id}
                to={service.path}
                className="text-[15px] text-primary-300 hover:text-primary-200 transition-colors duration-300"
              >
                {service.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="text-[15px] text-primary-300 hover:text-primary-200 transition-colors duration-300"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}